import React, { useState } from 'react';
import styled from 'styled-components';

import media from '../../../utils/mediaQueries';
import Btn from '../../buttons/Btn';
import {
  colors, radius, shadows, spacing,
} from '../tokens';
import { DemarcheSituationOption } from '../types';
import { SituationOptionGroup } from './SituationOptionGroup';

const Wrapper = styled.div`
  max-width: 820px;
  margin: 0 auto;
  padding: ${spacing.xl};
  background-color: ${colors.surface};
  border: 1px solid ${colors.border};
  border-radius: ${radius.large};
  box-shadow: ${shadows.card};

  ${media.mobile`
    padding: 20px;
  `}
`;

const Title = styled.h2`
  font-size: 22px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: ${colors.text};
  margin: 0 0 ${spacing.xs};
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.1px;
  color: ${colors.textMuted};
  margin: 0;
`;

type DemarchePageSelectorProps = {
  slug: string;
  heading: string;
  subtitle: string;
  ctaLabel: string;
  options: DemarcheSituationOption[];
  // Answers that mean the visitor is on the wrong service page, mapped to the right one.
  redirects: Record<string, string>;
  tunnelUrl: string;
};

const DemarchePageSelector: React.FC<DemarchePageSelectorProps> = ({
  slug,
  heading,
  subtitle,
  ctaLabel,
  options,
  redirects,
  tunnelUrl,
}) => {
  const [selectedSituation, setSelectedSituation] = useState<string | null>(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    if (!selectedSituation) {
      return;
    }

    const redirect = redirects[selectedSituation];

    if (redirect) {
      window.location.assign(`${redirect}#situation`);

      return;
    }

    const query = `demarche=${encodeURIComponent(slug)}&situation=${encodeURIComponent(selectedSituation)}`;

    window.location.assign(`${tunnelUrl}?${query}`);
  };

  return (
    <Wrapper>
      <Title>{heading}</Title>
      <Text>{subtitle}</Text>
      <form onSubmit={handleSubmit}>
        <SituationOptionGroup
          name="demarche-situation"
          ariaLabel={heading}
          options={options}
          selectedValue={selectedSituation}
          onSelect={setSelectedSituation}
        />
        <Btn
          type="submit"
          name="demarche-page-continue"
          text={ctaLabel || 'Continuer'}
          block
          disabled={!selectedSituation}
        />
      </form>
    </Wrapper>
  );
};

export { DemarchePageSelector };
